import { useState, useEffect, useCallback } from 'react';
import { getStats, Stats } from '../utils/api';

const REFRESH_INTERVAL = 30000; // 30 seconds

export function StatsBar() {
  const [stats, setStats] = useState<Stats | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchStats = useCallback(async () => {
    try {
      const data = await getStats();
      setStats(data);
      setError(null);
    } catch (err) {
      setError('Failed to load stats');
      console.error('Stats fetch error:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchStats();

    const interval = setInterval(fetchStats, REFRESH_INTERVAL);
    return () => clearInterval(interval);
  }, [fetchStats]);

  if (loading && !stats) {
    return (
      <div className="stats-grid">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="stat-card">
            <div className="stat-value" style={{ opacity: 0.3 }}>
              --
            </div>
            <div className="stat-label">Loading...</div>
          </div>
        ))}
      </div>
    );
  }

  if (error && !stats) {
    return (
      <div className="stats-grid">
        <div className="stat-card" style={{ gridColumn: '1 / -1' }}>
          <div className="stat-label" style={{ color: 'var(--danger)' }}>
            {error}
          </div>
        </div>
      </div>
    );
  }

  const topLocation =
    stats?.topCountries?.[0]?.country || 'No data';

  return (
    <div className="stats-grid">
      <div className="stat-card">
        <div className="stat-value">{stats?.totalOpens ?? 0}</div>
        <div className="stat-label">Total Opens</div>
      </div>
      <div className="stat-card">
        <div className="stat-value">{stats?.uniqueEmails ?? 0}</div>
        <div className="stat-label">Emails Tracked</div>
      </div>
      <div className="stat-card">
        <div className="stat-value">{stats?.todayOpens ?? 0}</div>
        <div className="stat-label">Opens Today</div>
      </div>
      <div className="stat-card">
        <div className="stat-value" style={{ fontSize: '1.5rem' }}>
          {topLocation}
        </div>
        <div className="stat-label">Top Location</div>
      </div>
    </div>
  );
}
